import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

const QueryKey = 'oil-analysis-user-search'
const CACHE_TIME_IN_MS = 1000 * 60

type UseOilAnalysisUserSearchOptions = Omit<
  UseQueryOptions<User[], AxiosError>,
  'queryKey' | 'queryFn'
>

export const useOilAnalysisUserSearch = (
  plantUpmId: string,
  namePattern: string | undefined,
  options?: UseOilAnalysisUserSearchOptions
) => {
  return useQuery<User[], AxiosError>({
    queryKey: [QueryKey, namePattern, plantUpmId],
    queryFn: async ({signal}) => {
      if (!plantUpmId || !namePattern) {
        return []
      }

      const path = `${TasksApiPath.OIL_ANALYSIS_ACTIONS}/${plantUpmId}/users`
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })

      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
